export const sizeOptions = ['xs', 'sm', 'md', 'lg'];

export const variantProps = ['contained', 'outline', 'link'];

export const colorOptions = ['primary', 'secondary'];
